// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g-root {
  --dl-navigation-breadcrumbs-height: 28px;
  --dl-revision-panel-top-offset: 40px;
  --dl-color-border: var(--g-color-line-generic);
  --dl-color-border-solid: var(--g-color-line-generic-solid);
  --dl-color-progress-bar: var(--g-color-text-info);
  --dl-color-progress-bar-failed: var(--g-color-base-danger-heavy);
  --dl-color-field-dimenson: var(--g-color-base-positive-light);
  --dl-color-field-dimenson-hover: var(--g-color-base-positive-light-hover);
  --dl-color-field-measure: var(--g-color-base-info-light);
  --dl-color-field-measure-hover: var(--g-color-base-info-light-hover);
  --dl-color-field-dimenson-solid: var(--g-color-text-positive);
  --dl-color-field-measure-solid: var(--g-color-text-info);
  --dl-color-entity-chart-wizard: #5282ff;
  --dl-color-entity-chart-ql: #9f6fee;
  --dl-color-entity-chart-editor: #e18c1e;
  --dl-color-entity-connection: #9a32a6;
  --dl-color-entity-dataset: #0abe05;
  --dl-color-entity-dashboard: #ff8c3c;
  --dl-color-widget-background: var(--g-color-base-float);
  --dl-color-text-workbook-icon: var(--g-color-text-dark-primary);
  --dl-viz-icon-main-color: #3d97f2;
  --dl-viz-icon-secondary-color: #ff6a59;
}
.g-root_theme_light {
  --g-color-private-cool-grey-20-solid: rgb(245, 246, 247);
  --ds-color-relation-line: #d9d9d9;
  --ds-color-avatar: #ededed;
  --w-local-item-border: rgba(0, 0, 0, 0.5);
  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);
  --w-disabled-item-background: rgba(0, 0, 0, 0.07);
  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);
  --dl-color-base-workbook-icon: #d1dfff;
  --dl-filter-ymap-background: none;
  --dl-filter-ymap-heatmap: none;
  --dl-color-ymap-background: #fafafa;
  --dl-filter-zoom-control: none;
  --dl-color-dashboard-background: var(--g-color-private-cool-grey-20-solid);
  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-100-solid);
}
.g-root_theme_light-hc {
  --ds-color-relation-line: #d9d9d9;
  --ds-color-avatar: #ededed;
  --w-local-item-border: rgba(0, 0, 0, 0.5);
  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);
  --w-disabled-item-background: rgba(0, 0, 0, 0.07);
  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);
  --dl-color-base-workbook-icon: #a8c3ff;
  --dl-filter-ymap-background: none;
  --dl-filter-ymap-heatmap: none;
  --dl-color-ymap-background: #fafafa;
  --dl-filter-zoom-control: none;
  --dl-color-dashboard-background: var(--g-color-private-cool-grey-50-solid);
  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-150-solid);
}
.g-root_theme_dark {
  --g-color-private-white-20-solid: rgb(49, 48, 55);
  --ds-color-relation-line: #4c4b51;
  --ds-color-avatar: #3b3a41;
  --w-local-item-border: rgba(255, 255, 255, 0.5);
  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);
  --w-disabled-item-background: rgba(255, 255, 255, 0.07);
  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);
  --dl-color-base-workbook-icon: #c2d0f0;
  --dl-filter-ymap-background: invert(0.9) saturate(0.4) hue-rotate(-30deg);
  --dl-filter-ymap-heatmap: invert(0.9) saturate(0.4) hue-rotate(-30deg);
  --dl-color-ymap-background: transparent;
  --dl-filter-zoom-control: invert(1);
  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);
  --dl-color-fixed-header-background: var(--g-color-base-background);
}
.g-root_theme_dark-hc {
  --g-color-private-white-20-solid: rgb(38, 39, 42);
  --ds-color-relation-line: #4c4b51;
  --ds-color-avatar: #3b3a41;
  --w-local-item-border: rgba(255, 255, 255, 0.5);
  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);
  --w-disabled-item-background: rgba(255, 255, 255, 0.07);
  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);
  --dl-color-base-workbook-icon: #c0d3fd;
  --dl-filter-ymap-background: invert(0.95) saturate(0.4) hue-rotate(-30deg);
  --dl-filter-ymap-heatmap: invert(0.95) saturate(0.4) hue-rotate(-30deg);
  --dl-color-ymap-background: transparent;
  --dl-filter-zoom-control: invert(1);
  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);
  --dl-color-fixed-header-background: var(--g-color-base-background);
}

@keyframes pulseAnimation {
  0% {
    opacity: 0.65;
  }
  50% {
    opacity: 0.35;
  }
  100% {
    opacity: 0.65;
  }
}
.expandable-panel {
  padding: 0;
  z-index: 100;
  width: 246px;
  box-sizing: border-box;
  pointer-events: none;
}
.expandable-panel_collapsed {
  height: auto;
}
.active + .expandable-panel_collapsed {
  height: auto;
}
.expandable-panel_collapsed .expandable-panel__container {
  height: auto;
}
.expandable-panel_collapsed .expandable-panel__header {
  border-radius: 8px;
}
.expandable-panel_collapsed .expandable-panel__content {
  max-height: 0;
}
.expandable-panel__container {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: inherit;
}
.expandable-panel__header {
  padding: var(--g-spacing-4) var(--g-spacing-5);
  border-radius: 8px 8px 0 0;
}
.expandable-panel__content {
  padding: 0;
  overflow: hidden;
  border-radius: 0 0 8px 8px;
  position: relative;
}
.expandable-panel__header, .expandable-panel__content {
  background-color: var(--g-color-base-background);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
  pointer-events: initial;
}
.expandable-panel__shadow-putty {
  position: relative;
  z-index: 2;
}
.expandable-panel__shadow-putty:before {
  content: "";
  position: absolute;
  height: 6px;
  width: 100%;
  top: -3px;
  background-color: var(--g-color-base-background);
}
.expandable-panel__description {
  margin-top: 8px;
}
.expandable-panel__title {
  font-weight: 500;
  color: var(--g-color-text-primary);
  font-size: var(--g-text-body-1-font-size);
  line-height: calc(var(--g-text-body-1-line-height) * 1.15);
  position: relative;
  padding-right: 42px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.expandable-panel__title-text {
  color: var(--g-color-text-primary);
}
.expandable-panel__close, .expandable-panel__arrow {
  margin: 0;
  padding: 0;
  font-size: inherit;
  font-weight: 400;
  color: inherit;
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: var(--g-color-text-primary);
}
.expandable-panel__close:hover, .expandable-panel__close:before, .expandable-panel__close:hover:before, .expandable-panel__arrow:hover, .expandable-panel__arrow:before, .expandable-panel__arrow:hover:before {
  background: none;
  color: var(--g-color-text-primary);
}
.expandable-panel__close:active {
  transform: translateY(-50%);
}
.expandable-panel__arrow {
  right: 20px;
  transition: transform 0.1s ease-out;
}
.expandable-panel__arrow:active {
  transform: translateY(-50%);
}
.expandable-panel__arrow_expanded, .expandable-panel__arrow_expanded:active {
  transform: translateY(-50%) rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/variables.scss","webpack://./src/ui/components/ExpandablePanel/ExpandablePanel.scss","webpack://./src/ui/styles/mixins.scss"],"names":[],"mappings":"AA6BA;EACI,wCAAA;EACA,oCAAA;EAEA,8CAAA;EACA,0DAAA;EACA,iDAAA;EACA,gEAAA;EAEA,6DAAA;EACA,yEAAA;EACA,wDAAA;EACA,oEAAA;EACA,6DAAA;EACA,wDAAA;EAEA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;EACA,kCAAA;EACA,oCAAA;EAEA,uDAAA;EAEA,+DAAA;EAEA,iCAAA;EACA,sCAAA;AClCJ;ADoCI;EAEI,wDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,iDAAA;EACA,0CAAA;EACA,sCAAA;EACA,iCAAA;EACA,8BAAA;EACA,mCAAA;EACA,8BAAA;EACA,0EAAA;EACA,8EAAA;ACpCR;ADuCI;EACI,iCAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,iDAAA;EACA,0CAAA;EACA,sCAAA;EACA,iCAAA;EACA,8BAAA;EACA,mCAAA;EACA,8BAAA;EACA,0EAAA;EACA,8EAAA;ACrCR;ADwCI;EACI,iDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,+CAAA;EACA,wDAAA;EACA,uDAAA;EACA,gDAAA;EACA,sCAAA;EACA,yEAAA;EACA,sEAAA;EACA,uCAAA;EACA,mCAAA;EACA,sEAAA;EACA,kEAAA;ACvCR;AD0CI;EACI,iDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,+CAAA;EACA,wDAAA;EACA,uDAAA;EACA,gDAAA;EACA,sCAAA;EACA,0EAAA;EACA,uEAAA;EACA,uCAAA;EACA,mCAAA;EACA,sEAAA;EACA,kEAAA;ACzCR;;ACuEA;EACI;IACI,aAAA;EDpEN;ECsEE;IACI,aAAA;EDpEN;ECsEE;IACI,aAAA;EDpEN;AACF;AA5FA;EAEI,UAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AA6FJ;AA3FI;EACI,YAAA;AA6FR;AA3FQ;EACI,YAAA;AA6FZ;AA1FQ;EACI,YAAA;AA4FZ;AAzFQ;EACI,kBAAA;AA2FZ;AAxFQ;EACI,aAAA;AA0FZ;AAtFI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAwFR;AArFI;EACI,8CAAA;EACA,0BAAA;AAuFR;AApFI;EACI,UAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAsFR;AAnFI;EAEI,gDAAA;EACA,yCAAA;EACA,uBAAA;AAoFR;AAjFI;EACI,kBAAA;EACA,UAAA;AAmFR;AAjFQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,gDAAA;AAmFZ;AA/EI;EACI,eAAA;AAiFR;AA9EI;EACI,gBAAA;EACA,kCAAA;EACA,yCAAA;EACA,0DA9EU;EA+EV,kBAAA;EACA,mBAAA;EChFJ,mBAAA;EACA,gBAAA;EACA,uBAH4B;ADoKhC;AA/EI;EACI,kCAAA;AAiFR;AA9EI;EClFA,SAAA;EACA,UAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;ED2EI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,kCAAA;AAuFR;AArFQ;EAGI,gBAAA;EACA,kCAAA;AAqFZ;AAjFI;EACI,2BAAA;AAmFR;AAhFI;EACI,WAAA;EACA,mCAAA;AAkFR;AAhFQ;EACI,2BAAA;AAkFZ;AA/EQ;EAEI,0CAAA;AAgFZ","sourcesContent":[null,".g-root {\n  --dl-navigation-breadcrumbs-height: 28px;\n  --dl-revision-panel-top-offset: 40px;\n  --dl-color-border: var(--g-color-line-generic);\n  --dl-color-border-solid: var(--g-color-line-generic-solid);\n  --dl-color-progress-bar: var(--g-color-text-info);\n  --dl-color-progress-bar-failed: var(--g-color-base-danger-heavy);\n  --dl-color-field-dimenson: var(--g-color-base-positive-light);\n  --dl-color-field-dimenson-hover: var(--g-color-base-positive-light-hover);\n  --dl-color-field-measure: var(--g-color-base-info-light);\n  --dl-color-field-measure-hover: var(--g-color-base-info-light-hover);\n  --dl-color-field-dimenson-solid: var(--g-color-text-positive);\n  --dl-color-field-measure-solid: var(--g-color-text-info);\n  --dl-color-entity-chart-wizard: #5282ff;\n  --dl-color-entity-chart-ql: #9f6fee;\n  --dl-color-entity-chart-editor: #e18c1e;\n  --dl-color-entity-connection: #9a32a6;\n  --dl-color-entity-dataset: #0abe05;\n  --dl-color-entity-dashboard: #ff8c3c;\n  --dl-color-widget-background: var(--g-color-base-float);\n  --dl-color-text-workbook-icon: var(--g-color-text-dark-primary);\n  --dl-viz-icon-main-color: #3d97f2;\n  --dl-viz-icon-secondary-color: #ff6a59;\n}\n.g-root_theme_light {\n  --g-color-private-cool-grey-20-solid: rgb(245, 246, 247);\n  --ds-color-relation-line: #d9d9d9;\n  --ds-color-avatar: #ededed;\n  --w-local-item-border: rgba(0, 0, 0, 0.5);\n  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);\n  --w-disabled-item-background: rgba(0, 0, 0, 0.07);\n  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);\n  --dl-color-base-workbook-icon: #d1dfff;\n  --dl-filter-ymap-background: none;\n  --dl-filter-ymap-heatmap: none;\n  --dl-color-ymap-background: #fafafa;\n  --dl-filter-zoom-control: none;\n  --dl-color-dashboard-background: var(--g-color-private-cool-grey-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-100-solid);\n}\n.g-root_theme_light-hc {\n  --ds-color-relation-line: #d9d9d9;\n  --ds-color-avatar: #ededed;\n  --w-local-item-border: rgba(0, 0, 0, 0.5);\n  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);\n  --w-disabled-item-background: rgba(0, 0, 0, 0.07);\n  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);\n  --dl-color-base-workbook-icon: #a8c3ff;\n  --dl-filter-ymap-background: none;\n  --dl-filter-ymap-heatmap: none;\n  --dl-color-ymap-background: #fafafa;\n  --dl-filter-zoom-control: none;\n  --dl-color-dashboard-background: var(--g-color-private-cool-grey-50-solid);\n  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-150-solid);\n}\n.g-root_theme_dark {\n  --g-color-private-white-20-solid: rgb(49, 48, 55);\n  --ds-color-relation-line: #4c4b51;\n  --ds-color-avatar: #3b3a41;\n  --w-local-item-border: rgba(255, 255, 255, 0.5);\n  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);\n  --w-disabled-item-background: rgba(255, 255, 255, 0.07);\n  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);\n  --dl-color-base-workbook-icon: #c2d0f0;\n  --dl-filter-ymap-background: invert(0.9) saturate(0.4) hue-rotate(-30deg);\n  --dl-filter-ymap-heatmap: invert(0.9) saturate(0.4) hue-rotate(-30deg);\n  --dl-color-ymap-background: transparent;\n  --dl-filter-zoom-control: invert(1);\n  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-base-background);\n}\n.g-root_theme_dark-hc {\n  --g-color-private-white-20-solid: rgb(38, 39, 42);\n  --ds-color-relation-line: #4c4b51;\n  --ds-color-avatar: #3b3a41;\n  --w-local-item-border: rgba(255, 255, 255, 0.5);\n  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);\n  --w-disabled-item-background: rgba(255, 255, 255, 0.07);\n  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);\n  --dl-color-base-workbook-icon: #c0d3fd;\n  --dl-filter-ymap-background: invert(0.95) saturate(0.4) hue-rotate(-30deg);\n  --dl-filter-ymap-heatmap: invert(0.95) saturate(0.4) hue-rotate(-30deg);\n  --dl-color-ymap-background: transparent;\n  --dl-filter-zoom-control: invert(1);\n  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-base-background);\n}\n\n@keyframes pulseAnimation {\n  0% {\n    opacity: 0.65;\n  }\n  50% {\n    opacity: 0.35;\n  }\n  100% {\n    opacity: 0.65;\n  }\n}\n.expandable-panel {\n  padding: 0;\n  z-index: 100;\n  width: 246px;\n  box-sizing: border-box;\n  pointer-events: none;\n}\n.expandable-panel_collapsed {\n  height: auto;\n}\n.active + .expandable-panel_collapsed {\n  height: auto;\n}\n.expandable-panel_collapsed .expandable-panel__container {\n  height: auto;\n}\n.expandable-panel_collapsed .expandable-panel__header {\n  border-radius: 8px;\n}\n.expandable-panel_collapsed .expandable-panel__content {\n  max-height: 0;\n}\n.expandable-panel__container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: inherit;\n}\n.expandable-panel__header {\n  padding: var(--g-spacing-4) var(--g-spacing-5);\n  border-radius: 8px 8px 0 0;\n}\n.expandable-panel__content {\n  padding: 0;\n  overflow: hidden;\n  border-radius: 0 0 8px 8px;\n  position: relative;\n}\n.expandable-panel__header, .expandable-panel__content {\n  background-color: var(--g-color-base-background);\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);\n  pointer-events: initial;\n}\n.expandable-panel__shadow-putty {\n  position: relative;\n  z-index: 2;\n}\n.expandable-panel__shadow-putty:before {\n  content: \"\";\n  position: absolute;\n  height: 6px;\n  width: 100%;\n  top: -3px;\n  background-color: var(--g-color-base-background);\n}\n.expandable-panel__description {\n  margin-top: 8px;\n}\n.expandable-panel__title {\n  font-weight: 500;\n  color: var(--g-color-text-primary);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: calc(var(--g-text-body-1-line-height) * 1.15);\n  position: relative;\n  padding-right: 42px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.expandable-panel__title-text {\n  color: var(--g-color-text-primary);\n}\n.expandable-panel__close, .expandable-panel__arrow {\n  margin: 0;\n  padding: 0;\n  font-size: inherit;\n  font-weight: 400;\n  color: inherit;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: var(--g-color-text-primary);\n}\n.expandable-panel__close:hover, .expandable-panel__close:before, .expandable-panel__close:hover:before, .expandable-panel__arrow:hover, .expandable-panel__arrow:before, .expandable-panel__arrow:hover:before {\n  background: none;\n  color: var(--g-color-text-primary);\n}\n.expandable-panel__close:active {\n  transform: translateY(-50%);\n}\n.expandable-panel__arrow {\n  right: 20px;\n  transition: transform 0.1s ease-out;\n}\n.expandable-panel__arrow:active {\n  transform: translateY(-50%);\n}\n.expandable-panel__arrow_expanded, .expandable-panel__arrow_expanded:active {\n  transform: translateY(-50%) rotate(180deg);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
